import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import theme from "themes/simple-theme";

const CheckedSegmentationDetail = () => (
  <FontAwesomeIcon
    icon="check"
    size="3x"
    style={{
      height: 77,
      width: 72,
      lineHeight: "72px",
      textAlign: "center",
      color: theme.color.primary
    }}
  />
);

export default CheckedSegmentationDetail;



// WEBPACK FOOTER //
// ./src/components/ElementSelector/Common/CheckedSegmentationDetail.tsx